// extracted by mini-css-extract-plugin
export var avatarContainer = "_4s-1";
export var largeAvatarContainer = "_4s-2";
export var smallAvatarContainer = "_4s-0";